package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.list_device


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ListDevices(
    @SerialName("cursors")
    val cursors: Cursors?,
    @SerialName("items")
    val items: List<DeviceItem?>?,
    @SerialName("__typename")
    val typename: String?
)